<template>
	<div class="dropzone-wrapper" :class="{ hover }">
		<div
			class="dropzone-interior"
			@dragenter.prevent="dragOver"
			@dragover.prevent="dragOver"
			@dragleave.prevent="dragOff"
			@drop.prevent="onFileDrop"
		>
			<div class="dropzone-content">
				<UploadCloudActiveIcon v-show="hover" />
				<UploadCloudInactiveIcon v-show="!hover" />
				<div class="dropzone-text">
					{{ hover ? $t('chat_file_drop') : $t('chat_file_drag') }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { UploadCloudActiveIcon, UploadCloudInactiveIcon } from '@/icons'
export default {
	components: { UploadCloudActiveIcon, UploadCloudInactiveIcon },
	name: 'DropZone',
	data() {
		return { hover: false }
	},
	emits: ['drop-files'],
	methods: {
		dragOver() {
			this.hover = true
		},
		dragOff() {
			this.hover = false
		},
		onFileDrop(e) {
			this.hover = false
			const { files } = e.dataTransfer
			if (!files || !files.length) return
			this.$emit('drop-files', files)
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.dropzone-wrapper {
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	@include max-z;
	position: absolute;
	padding: 15px;
	background-color: #222;
	&.hover {
		.dropzone-interior {
			border-color: var(--teal-300);
			border-style: solid;
		}
	}
}
.dropzone-interior {
	width: 100%;
	height: 100%;
	border: 2px #3c3c3c dashed;
	display: flex;
	align-items: center;
	justify-content: center;
}

.dropzone-content {
	text-align: center;
	width: 160px;
	pointer-events: none;
	img {
		width: 99px;
	}
}
.dropzone-text {
	font-family: Avenir-Medium;
	font-size: 18px;
	font-weight: 500;
	font-style: normal;
	font-stretch: normal;
	line-height: 0.78;
	letter-spacing: normal;
	text-align: center;
	color: #7e7e7e;
	margin-top: 11px;
}
</style>
